// extracted by mini-css-extract-plugin
module.exports = {"root":"u_x03Icl","coloredValue":"yIutGOaW","nonNumericText":"kwYI5mdB"};